import { HierarchyDto, NonUSFProduct, PIMClass } from '@usf/product-types';
import {
  ExternalVendorState,
  NonUsfProductSortOptions,
} from '@usf/ngrx-product';
import { FormGroup } from '@angular/forms';
import { PlatformEnum } from '@panamax/app-state';

export interface NonUSFProductViewModel extends NonUSFProduct {
  isSelected: boolean;
  vendorName: string;
  glCode?: string;
}

export interface manageNonUsfProductsViewModel {
  products: NonUSFProductViewModel[];
  vendors: ExternalVendorState[];
  itemHeights: number[];
  sortOptions: NonUsfProductSortOptions;
  totalNonUsfProducts: number;
  showDownloadGlCode: boolean;
}

export interface vendorDropdownEvent {
  event: Event;
  vendors: ExternalVendorState[];
}

export interface AddNonUsfViewModel {
  usfProductForm: FormGroup;
  platform: PlatformEnum;
  vendors: ExternalVendorState[];
  pimData: PIMClass[];
  pimClassHeirachy: HierarchyDto;
  pimCategoryHeirarchy: HierarchyDto;
  pimGroupHeirarchy: HierarchyDto;
  originalProduct: NonUSFProductViewModel;
  isAndroidTouch: boolean;
  isEditMode: boolean;
  dismisEvent: Function;
  submitEvent: Function;
  vendorsEvent: Function;
  priceOptionEvent: Function;
  unitsEvent: Function;
  pimCodeEvent: Function;
  pimFlag: boolean;
}

export interface PIMSelectionViewModel {
  level: PIMLevelEnum;
  heirarchyData: HierarchyDto[];
  callbackSaveChange: Function;
  dismissFunction: Function;
  searchPlaceholder: string;
  platform: PlatformEnum;
  title: string;
  initialSelection?: HierarchyDto;
}

export enum PIMLevelEnum {
  class,
  category,
  group,
}

export interface NonUsfRadioItem {
  productName: string;
  vendorName: string;
  productNumber?: number;
  selected: boolean;
  packSize?: string;
  price?: number;
  manufacturerNumber?: string;
}

export interface AlternateNonUsf {
  selected: boolean;
  fullProduct: NonUSFProductViewModel;
}
